import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sheet, SheetClose, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { GameController, List } from '@phosphor-icons/react';

const links = [
  { to: '/guides', label: 'Guides' },
  { to: '/about', label: 'About' },
  { to: '/faq', label: 'FAQ' },
  { to: '/contact', label: 'Contact' },
];

export const SiteHeader = () => {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-[#E4E4E7]" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3" data-testid="site-header-home-link">
          <span className="bg-[#0047FF] p-2"><GameController size={22} weight="fill" color="#FFFFFF" /></span>
          <span className="font-heading text-lg font-bold tracking-tight text-[#09090B]">DashLink Gaming</span>
        </Link>
        <nav className="hidden md:flex items-center gap-7" aria-label="Main">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`site-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm transition-colors ${isActive ? 'text-[#0047FF] font-medium' : 'text-[#71717A] hover:text-[#09090B]'}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Button onClick={() => navigate('/auth')} className="bg-[#0047FF] hover:bg-[#0037CC] text-white" data-testid="site-header-launch-app">
            Launch App
          </Button>
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="md:hidden" aria-label="Open menu" data-testid="site-mobile-menu-button">
                <List size={22} />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-64" data-testid="site-mobile-menu">
              <nav className="mt-10 flex flex-col gap-5" aria-label="Mobile">
                {links.map((l) => (
                  <SheetClose asChild key={l.to}>
                    <Link to={l.to} className="font-heading text-lg font-bold text-[#09090B] hover:text-[#0047FF]" data-testid={`site-mobile-nav-${l.label.toLowerCase()}`}>
                      {l.label}
                    </Link>
                  </SheetClose>
                ))}
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
